<section>

  <section class="table-content">
    <section class="filters">
      <input (input)="getTeachers('search', searchTeachers)" [(ngModel)]="searchTeachers" type="search"
             name="searchTeachers" placeholder="Search name, username or staff number...">

      <div>
        @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
          <select (change)="getTeachers('school_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId"
                  id="schoolId">
            <option value="" hidden disabled>Select a school</option>

            @for (s of schools()?.payload; track $index) {
              <option [value]="s.id">{{ Helpers.capitalizeWords(s.school_name) }}</option>
            }

          </select>
        }

        <select (change)="getTeachers('status', teacherStatus)" [(ngModel)]="teacherStatus" name="teacherStatus">
          <option value="" hidden disabled>Select a status</option>
          <option value="">All Statuses</option>

          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
          <option value="ARCHIVED">Archived</option>
        </select>
      </div>
    </section>

    <div class="table-wrapper">
      <table>
        <thead>
        <tr>
          <th>TEACHER ID</th>
          <th>NAME</th>
          <th>USERNAME</th>
          <th>STAFF NUMBER</th>
          <th>STATUS</th>
          <th class="options-column">ACTIONS</th>
        </tr>
        </thead>

        <tbody>
          @if (isFiltering()) {
            <td colspan="6">
              <app-loading-indicator />
            </td>
          } @else {
            @if (!teachers()?.payload?.length) {
              <tr>
                <td colspan="6" class="empty">
                  <app-not-found-error>
                    NO TEACHERS FOUND
                  </app-not-found-error>
                </td>
              </tr>
            } @else {
              @for (u of teachers()?.payload; track u.id) {
                <tr>
                  <td>
                    {{ u.public_id }}
                  </td>

                  <td>
                    {{ ((u?.first_name ?? '') + ' ' + (u?.last_name)) }}
                  </td>

                  <td>
                    {{ u.username }}
                  </td>

                  <td>
                    {{ u.staff_number ? u.staff_number.toUpperCase() : 'N/A' }}
                  </td>

                  <td class="status">
                    <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                  </td>

                  <td class="options-column">
                    <app-action-button>
                      <button (click)="selectTeacher('view',u)" type="button" class="menu-item">
                        View details
                      </button>

                      <button (click)="selectTeacher('edit',u)" type="button" class="menu-item">Edit details</button>

                      <button (click)="selectTeacher('status',u)" type="button" class="menu-item">Change status</button>
                    </app-action-button>
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      [page]="teachers()?.pagination?.page ?? 0"
      [size]="teachers()?.pagination?.size ?? 10"
      [totalElements]="teachers()?.pagination?.totalElements ?? 0"
      [totalPages]="teachers()?.pagination?.totalPages ?? 0"
      [first]="teachers()?.pagination?.first ?? true"
      [last]="teachers()?.pagination?.last ?? false"
      [hasNext]="teachers()?.pagination?.hasNext ?? false"
      [hasPrevious]="teachers()?.pagination?.hasPrevious ?? false"
      (pageChange)="loadTeacherPage($event)">
    </app-pagination>

  </section>

</section>


<section [class.show]="setTeacherDetail()" class="slider">
  <div class="bg" (click)="setTeacherDetail.set(false)"></div>

  <div class="slider-content">
    <div class="slider-heading">
      <div>
        <h5>{{ selectedTeacher.first_name }} {{ selectedTeacher.last_name }}</h5>
        <small>{{ selectedTeacher.public_id }}</small>
      </div>

      <div class="status">
        <p [ngClass]="selectedTeacher.status">{{ Helpers.replaceUnderscore(selectedTeacher.status) }}</p>
      </div>
    </div>

    <div class="transaction-info">
      <h6>TEACHER INFO</h6>

      <div class="transaction-container">

        <div>
          <small>Username</small>
          <p>&#64;{{ selectedTeacher.username }}</p>
        </div>

        <div>
          <small>Staff number</small>
          <p>{{ selectedTeacher.staff_number }}</p>
        </div>

        <div>
          <small>Employment type</small>
          <p>{{ Helpers.capitalizeWords(Helpers.replaceUnderscore(selectedTeacher.employment_type)) }}</p>
        </div>

        @if (selectedTeacher.hire_date.length) {
          <div>
            <small>Joined</small>
            <p>{{ Helpers.formatDate(selectedTeacher.hire_date) }}</p>
          </div>
        }

        @if (selectedTeacher.phone.length) {
          <div>
            <small>Phone</small>
            <p>{{ selectedTeacher.phone }}</p>
          </div>
        }

        @if (selectedTeacher.specialization.length) {
          <div>
            <small>Specialization</small>
            <p>{{ selectedTeacher.specialization }}</p>
          </div>
        }

        @if (selectedTeacher.qualification.length) {
          <div>
            <small>Qualifications</small>
            <p style="text-align: right">
              @for (q of selectedTeacher.qualification; track $index) {
                {{ q }} <br>
              }
            </p>
          </div>
        }
      </div>
    </div>

    <div class="fee-summary">
      <h6>ASSIGNED CLASSES</h6>

      @if (!classes()?.payload?.length) {
        <h3 class="error">TEACHER IS NOT ASSIGNED TO ANY CLASS CURRENTLY</h3>
      } @else {

        <div class="level-container">
          @for (l of classes()?.payload; track $index) {
            <div class="level-row">
              <!--              <h6></h6>-->

              <div class="level-name">
                <p>{{ l.level_name }}{{ l.name }}</p>
                <small>{{ l.public_id }}</small>
              </div>

              <div class="status">
                <p [ngClass]="l.status">{{ l.status }}</p>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <div class="fee-summary subject-teacher">
      <h6>SUBJECTS TAUGHT</h6>

      @if (!teacherClassSubjects()?.payload?.length) {
        <h3 class="error">NO ASSIGNED SUBJECTS CURRENTLY</h3>
      } @else {
        <div class="level-container">
          @for (l of teacherClassSubjects()?.payload; track $index) {
            <div class="level-row class-teacher">
              <h6>{{ l.subject_code }}</h6>

              <div class="level-name">
                <p>{{ l.subject_name }}</p>
                <small>{{ l.level_name }}{{ l.class_name }}</small>
              </div>

              <p class="academic-year">{{ l.academic_year_name }}</p>
            </div>
          }
        </div>
      }

    </div>

    @if (admins.includes(loggedUserRole ?? '')) {
      <div class="button-container">
        <button (click)="openAssignClass()" class="button assign-class" type="button">
          <svg viewBox="0 0 1024 1024" fill="#fff" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"
               stroke="#fff">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M427.84 547.52a193.6 193.6 0 1 0-193.6-193.6 193.92 193.92 0 0 0 193.6 193.6z m0-323.52a129.6 129.6 0 1 1-129.6 129.6A129.92 129.92 0 0 1 427.84 224zM822.72 937.28a32 32 0 0 0-45.44 0 32 32 0 0 0-6.72 10.56A32 32 0 0 0 768 960a32 32 0 1 0 64 0 32 32 0 0 0-2.56-12.16 32 32 0 0 0-6.72-10.56zM672 928h-128a32 32 0 0 0 0 64h128a32 32 0 0 0 0-64z"
                fill="#fff"></path>
              <path
                d="M776.96 861.76h2.24a32 32 0 0 0 4.8-3.52l3.84-3.2a32 32 0 0 0 3.84-5.76 20.16 20.16 0 0 0 4.16-10.88 32 32 0 0 0 0-5.76 32 32 0 0 0 0-6.4 30.08 30.08 0 0 0 0-4.8 394.56 394.56 0 0 0-367.36-256A400.64 400.64 0 0 0 32 960a32 32 0 0 0 32 32h352a32 32 0 0 0 0-64H98.56a335.04 335.04 0 0 1 329.28-299.84A330.88 330.88 0 0 1 736 843.52v2.56a32 32 0 0 0 15.04 14.4h1.6a28.48 28.48 0 0 0 23.04 0zM565.76 124.8a110.08 110.08 0 1 1 123.84 179.84 32 32 0 1 0 28.8 57.28 174.08 174.08 0 1 0-196.16-284.16 32 32 0 1 0 43.52 47.04zM675.2 389.44a32 32 0 0 0-6.4 64 293.44 293.44 0 0 1 256 256H832a32 32 0 0 0 0 64h128a32 32 0 0 0 32-32 359.36 359.36 0 0 0-316.8-352z"
                fill="#fff"></path>
            </g>
          </svg>
          Assign Teacher to Class
        </button>

        <button (click)="openAssignSubject()" class="button assign-subject" type="button">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M12 10.4V20M12 10.4C12 8.15979 12 7.03969 11.564 6.18404C11.1805 5.43139 10.5686 4.81947 9.81596 4.43597C8.96031 4 7.84021 4 5.6 4H4.6C4.03995 4 3.75992 4 3.54601 4.10899C3.35785 4.20487 3.20487 4.35785 3.10899 4.54601C3 4.75992 3 5.03995 3 5.6V16.4C3 16.9601 3 17.2401 3.10899 17.454C3.20487 17.6422 3.35785 17.7951 3.54601 17.891C3.75992 18 4.03995 18 4.6 18H7.54668C8.08687 18 8.35696 18 8.61814 18.0466C8.84995 18.0879 9.0761 18.1563 9.29191 18.2506C9.53504 18.3567 9.75977 18.5065 10.2092 18.8062L12 20M12 10.4C12 8.15979 12 7.03969 12.436 6.18404C12.8195 5.43139 13.4314 4.81947 14.184 4.43597C15.0397 4 16.1598 4 18.4 4H19.4C19.9601 4 20.2401 4 20.454 4.10899C20.6422 4.20487 20.7951 4.35785 20.891 4.54601C21 4.75992 21 5.03995 21 5.6V16.4C21 16.9601 21 17.2401 20.891 17.454C20.7951 17.6422 20.6422 17.7951 20.454 17.891C20.2401 18 19.9601 18 19.4 18H16.4533C15.9131 18 15.643 18 15.3819 18.0466C15.15 18.0879 14.9239 18.1563 14.7081 18.2506C14.465 18.3567 14.2402 18.5065 13.7908 18.8062L12 20"
                stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </g>
          </svg>
          Assign Teacher to Subject
        </button>
      </div>
    }

  </div>
</section>

@if (assignClass()) {
  <section class="pop-up">
    <div class="bg" (click)="assignClass.set(false)"></div>

    <form #assignClassForm="ngForm" (ngSubmit)="assignTeacherToClass(assignClassForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>
        <div>
          <h6>Assign {{ selectedTeacher.first_name }} to a Class</h6>
          <small>Select a class to assign as Class Teacher</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="academicYearId">Academic Year <span class="required-check">*</span></label>
          <select (change)="onAcademicYearChange()" required [(ngModel)]="selectedAcademicYearId"
                  name="academicYearId" id="academicYearId">
            <option value="" disabled>Select an academic year</option>

            @for (a of academicYears()?.payload; track a.id) {
              <option [value]="a.id">{{ a.name }}</option>
            }
          </select>
        </div>

        @if (selectedAcademicYearId && selectedAcademicYearId !== '') {
          <div>
            <label for="selectedClassId">Class <span class="required-check">*</span></label>
            <select required [(ngModel)]="selectedClassId" name="selectedClassId" id="selectedClassId">
              <option value="" disabled>Select a class</option>
              @for (c of classList()?.payload; track c.id) {
                <option [value]="c.id">{{ c.level_name }}{{ c.name }}</option>
              }
            </select>
          </div>
        }

        <button [disabled]="assignClassForm.invalid" class="secondary-button" type="submit">
          @if (isAssigning()) {
            <app-loading-indicator />
          } @else {
            Assign Class Teacher
          }
        </button>
      </div>
    </form>
  </section>
}

@if (assignSubject()) {
  <section class="pop-up">
    <div class="bg" (click)="assignSubject.set(false)"></div>

    <form #assignSubjectForm="ngForm" (ngSubmit)="assignTeacherToSubject(assignSubjectForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>
        <div>
          <h6>Assign Subject to {{ selectedTeacher.first_name }}</h6>
          <small>Teachers can be assigned to classes or subjects</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="academicYearId">Academic Year <span class="required-check">*</span></label>
          <select (change)="onAcademicYearChange()" required [(ngModel)]="selectedAcademicYearId"
                  name="academicYearId" id="academicYearId">
            <option value="" disabled>Select an academic year</option>

            @for (a of academicYears()?.payload; track a.id) {
              <option [value]="a.id">{{ a.name }}</option>
            }
          </select>
        </div>

        @if (selectedAcademicYearId && selectedAcademicYearId !== '') {
          <div>
            <label for="selectedClassId">Class <span class="required-check">*</span></label>
            <select (change)="loadLevelSubjects()" required [(ngModel)]="selectedClassId" name="selectedClassId"
                    id="selectedClassId">
              <option value="" disabled>Select a class</option>
              @for (c of classList()?.payload; track c.id) {
                <option [value]="c.id">{{ c.level_name }}{{ c.name }}</option>
              }
            </select>
          </div>
        }

        <div>
          <label for="selectedLevelSubjectId">Subject <span class="required-check">*</span></label>
          <select required [(ngModel)]="selectedLevelSubjectId" name="selectedLevelSubjectId"
                  id="selectedLevelSubjectId">
            <option value="" disabled>Select a subject</option>
            @for (ls of levelSubjects()?.payload; track ls.id) {
              <option [value]="ls.id">{{ ls.subject_name }} ({{ ls.subject_code }})</option>
            }
          </select>
        </div>

        <div>
          <label for="assignmentRole">Teacher Role <span class="required-check">*</span></label>
          <select required [(ngModel)]="assignmentRole" name="assignmentRole" id="assignmentRole">
            <option value="">Select a role</option>
            <option value="LEAD">Lead</option>
            <option value="ASSISTANT">Assistant</option>
            <option value="SUBSTITUTE">Substitute</option>
          </select>
        </div>

        <button [disabled]="assignSubjectForm.invalid" class="secondary-button" type="submit">
          @if (isAssigning()) {
            <app-loading-indicator />
          } @else {
            Assign Subject Teacher
          }
        </button>
      </div>
    </form>
  </section>
}

@if (changeStatus()) {
  <section class="pop-up">
    <div class="bg" (click)="changeStatus.set(false)"></div>

    <form #changeStatusForm="ngForm" (ngSubmit)="editTeacherFn(changeStatusForm, 'status')">
      <div class="form-heading">
        <div class="image-box">
          <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52"
               xml:space="preserve" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> <path
              d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z"></path>
              <path
                d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z"></path>
              <path
                d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z"></path>
              <path
                d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z"></path> </g></svg>
        </div>
        <div>
          <h6>Change Status</h6>
          <small>Updating status of {{ selectedTeacher.first_name }} {{ selectedTeacher.last_name }}</small>
        </div>
      </div>

      <div class="form-container">
        <div class="status">
          <small>Current status:</small>
          <p [ngClass]="selectedTeacher.status">{{ selectedTeacher.status }}</p>
        </div>

        <div>
          <label for="newStatus">New Status <span class="required-check">*</span></label>
          <select required [(ngModel)]="newStatus" name="newStatus" id="newStatus">
            <option value="" hidden disabled>Select a status</option>

            @for (s of validStatuses; track $index) {
              @if (s !== selectedTeacher.status) {
                <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
              }
            }
          </select>
        </div>

        <button class="secondary-button" [disabled]="changeStatusForm.invalid" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Change status
          }
        </button>

      </div>
    </form>
  </section>
}

@if (editLevel()) {
  <section class="pop-up">
    <div class="bg" (click)="editLevel.set(false)"></div>

    <form #editLevelForm="ngForm" (ngSubmit)="editTeacherFn(editLevelForm, 'edit')">
      <div class="form-heading">
        <div class="image-box">
          <svg height="200px" width="200px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
              fill: #fff;
            } </style>
              <g> <path class="st0"
                        d="M81.44,116.972c23.206,0,42.007-18.817,42.007-42.008c0-23.215-18.801-42.016-42.007-42.016 c-23.216,0-42.016,18.801-42.016,42.016C39.424,98.155,58.224,116.972,81.44,116.972z"></path>
                <path class="st0"
                      d="M224.166,245.037c0-0.856-0.142-1.673-0.251-2.498l62.748-45.541c3.942-2.867,4.83-8.411,1.963-12.362 c-1.664-2.285-4.342-3.652-7.17-3.652c-1.877,0-3.667,0.589-5.191,1.689l-62.874,45.636c-2.341-1.068-4.909-1.704-7.65-1.704 h-34.178l-8.294-47.222c-4.555-23.811-14.112-42.51-34.468-42.51h-86.3C22.146,136.873,0,159.019,0,179.383v141.203 c0,10.178,8.246,18.432,18.424,18.432c5.011,0,0,0,12.864,0l7.005,120.424c0,10.83,8.788,19.61,19.618,19.61 c8.12,0,28.398,0,39.228,0c10.83,0,19.61-8.78,19.61-19.61l9.204-238.53h0.463l5.27,23.269c1.744,11.097,11.293,19.28,22.524,19.28 h51.534C215.92,263.461,224.166,255.215,224.166,245.037z M68.026,218.861v-67.123h24.126v67.123l-12.817,15.118L68.026,218.861z"></path>
                <polygon class="st0"
                         points="190.326,47.47 190.326,200.869 214.452,200.869 214.452,71.595 487.874,71.595 487.874,302.131 214.452,302.131 214.452,273.113 190.326,273.113 190.326,326.256 512,326.256 512,47.47 "></polygon>
                <path class="st0"
                      d="M311.81,388.597c0-18.801-15.235-34.029-34.028-34.029c-18.801,0-34.036,15.228-34.036,34.029 c0,18.785,15.235,34.028,34.036,34.028C296.574,422.625,311.81,407.381,311.81,388.597z"></path>
                <path class="st0"
                      d="M277.781,440.853c-24.259,0-44.866,15.919-52.782,38.199h105.565 C322.648,456.771,302.04,440.853,277.781,440.853z"></path>
                <path class="st0"
                      d="M458.573,388.597c0-18.801-15.235-34.029-34.028-34.029c-18.801,0-34.036,15.228-34.036,34.029 c0,18.785,15.235,34.028,34.036,34.028C443.338,422.625,458.573,407.381,458.573,388.597z"></path>
                <path class="st0"
                      d="M424.545,440.853c-24.259,0-44.866,15.919-52.783,38.199h105.565 C469.411,456.771,448.804,440.853,424.545,440.853z"></path> </g> </g></svg>
        </div>

        <div>
          <h6>Edit Teacher</h6>
          <small>Update the details of {{ selectedTeacher.first_name }} {{ selectedTeacher.last_name }}</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="staffNumber">Staff Number <span class="required-check">*</span></label>
          <input required placeholder="e.g. STF103" [(ngModel)]="staffNumber" type="text" name="staffNumber"
                 id="staffNumber">
        </div>

        <div>
          <label for="employmentType">Employment Type <span class="required-check">*</span></label>

          <select [(ngModel)]="employmentType" name="employmentType" id="employmentType">
            <option value="">Select employment type</option>

            @for (a of allowedEmploymentTypes; track $index) {
              <option [value]="a">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(a)) }}</option>
            }
          </select>
        </div>


        <div>
          <label for="hireDate">Hire Date</label>
          <input [(ngModel)]="hireDate" type="date" name="hireDate" id="hireDate">
        </div>

        <div>
          <label for="specialization">Specialization</label>
          <input placeholder="e.g. Mathematics" [(ngModel)]="specialization" type="text" name="specialization"
                 id="specialization">
        </div>

        <div>
          <label for="qualification">Qualification</label>

          <div class="qualifications">

            <div>
              <input placeholder="e.g. BSc Mathematics" [(ngModel)]="qualification" type="text" name="qualification"
                     id="qualification">

              <button type="button" (click)="addQualification(editLevelForm)">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.99463 2.91443V11.0748" stroke="white" stroke-width="1.28234" />
                  <path d="M2.91443 6.9946H11.0748" stroke="white" stroke-width="1.28234" />
                </svg>

                <p>Add</p>
              </button>
            </div>

            <ul>
              @for (t of qualifications; track t.id) {
                <li>
                  <p class="list">{{ t.name }}</p>

                  <svg (click)="deleteQualification(t.id, editLevelForm)" fill="#fff" viewBox="-3.5 0 19 19"
                       xmlns="http://www.w3.org/2000/svg" class="cf-icon-svg" stroke="#fff">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M11.383 13.644A1.03 1.03 0 0 1 9.928 15.1L6 11.172 2.072 15.1a1.03 1.03 0 1 1-1.455-1.456l3.928-3.928L.617 5.79a1.03 1.03 0 1 1 1.455-1.456L6 8.261l3.928-3.928a1.03 1.03 0 0 1 1.455 1.456L7.455 9.716z"></path>
                    </g>
                  </svg>

                </li>
              }
            </ul>

          </div>

        </div>

        <div>
          <label for="phone">Phone</label>
          <input placeholder="e.g. 055..." [(ngModel)]="phone" type="text" name="phone" id="phone">
        </div>

        <button class="secondary-button" [disabled]="editLevelForm.invalid || editLevelForm.untouched">
          @if (isEditing()) {
            <app-loading-indicator />
          } @else {
            Update details
          }
        </button>
      </div>

    </form>
  </section>
}

